<template>
  <div v-if="isSupport" class="menu">
    <li
      class="list-group-item"
      v-on:click="isMenuOpened = !isMenuOpened"
    >
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/apri.svg'" alt="app_print" align="middle">
      <LabelFunMessage fcontId="0" msgkey="121" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>

    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <div class="app-message-area">
          <p class="app-message app-message-1">
            <!-- Webで印刷したいコンテンツを選び、エプソンのスマホアプリ「Epson Creative Print」、またはPCアプリ「Epson Photo＋」にダウンロードして印刷します。 -->
            <LabelFunMessage fcontId="0" msgkey="177" />
          </p>

          <!-- UT結果より、Create＋の名称を出すとユーザーが混乱するので表示しない -->
          <!-- <div class="app_info">
            <p class="app_title">
              Epson Create＋
            </p>
          </div> -->

          <p class="text-center modal-print-button">
            <a v-on:click="launchApp()" class="btn btn-info btn-lg" role="button">
              <!-- コンテンツを選択 -->
              <LabelFunMessage fcontId="0" msgkey="178" />&nbsp;&raquo;
            </a>
          </p>
        </div>
        <div class="app-caution">
          <p>
            <!-- 印刷するには、エプソンのスマホアプリ「Epson Creative Print」またはPCアプリ「Epson Photo＋」が必要です。 -->
            <LabelFunMessage fcontId="0" msgkey="179" />
          <br>
          <a v-on:click="clickLink()" role="button">
              <!-- ダウンロードはこちら -->
              <LabelFunMessage fcontId="0" msgkey="35" />
            </a>
          </p>
          
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import { CONTENT_TYPE } from "@/common/contentsinfo";
import { Collapse } from "uiv";


export default {
  name: "PrintMenuCreatePlus",
  props: {
    launchType: String, // select, print Create＋では未使用
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // Create＋では未使用
    designId: String, // Create＋では未使用
    mediaSizeId: String, // Create＋では未使用
    mediaTypeId: String, // Create＋では未使用
    fcontId: String,
    createplusCategoryId: String,
    createplusSubCategoryId: String,
    location_id: {  // 記事の作り方内で使う場合はmethodを入れる。複数ある場合は末尾に追番を入れる。
      type: String,
      default: "upper", 
      required: false
    }
  },
  data() {
    return {
      isMenuOpened: true,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,
    Collapse
  },
  computed: {
    ...mapState(["os","lg2"]),
    ...mapGetters(["isJpTemplate","isWwTemplate"]),

    isSupport: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.designpaperPremiumCollection:
          return true;
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.photolayout:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.album:  
        case CONTENT_TYPE.photobook: 
        case CONTENT_TYPE.designpaper:
        case CONTENT_TYPE.createplusContents: 
        case CONTENT_TYPE.creativeTop:
        default:
          return false;
      }
    },
    
  },
  methods: {
    // 別ウインドウで開く
    clickLink: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "create_guide"
      })
      let resolvedRoute = this.$router.resolve({ 
        path: "/createplus/" + this.lg2 + "/templates/guide",
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      });
      window.open(resolvedRoute.href, '_blank');
    },
      // 別ウインドウで開く
    launchApp: function () {
      this.$gtag.event("go_create", {
        "article_no": this.fcontId,
        "location_id": this.location_id,
        "item_category2": this.createplusSubCategoryId
      })

      let resolvedRoute = this.$router.resolve({ 
        path: "/createplus/" + this.lg2 + "/templates/" + this.createplusCategoryId + "/" + this.createplusSubCategoryId,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      });
      window.open(resolvedRoute.href, '_blank');
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.app-message-area {
  text-align: center;
}

.app-message-1 {
  margin-bottom: 10px;
}

.app_title {
  margin: 10px 10px 0px 10px;
  display: inline-block;
  vertical-align: center;
}

.app_info {
  text-align: center;
  margin: 20px auto;
}

.app_info img {
  display: inline-block;
  max-width: 80px;
}

p.modal-print-button a {
  padding: 10px 5px;
  width: 100%;
  max-width: 300px;
}

.app-caution {
  background-color: #eaeaea;
  padding: 10px;
}

.app-caution p {
  position: relative;
  padding-left: 1.25em;
}
.app-caution p:before {
  position: absolute;
  content: "*";
  left: 0;
  top: 0;
}

.app-caution table {
  background-color: white;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .app-caution p {
    font-size: 12px;
  }
}
</style>